import type { PayoutFee, PayoutMethod } from './PayoutDialog.types';
import { safeDateTimeFormat } from '@localization/safeIntl';

const INSTANT_PAYOUT_CALENDAR_DAYS = 1;
const STANDARD_PAYOUT_BUSINESS_DAYS = 7;

const addBusinessDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return result;
};

const addCalendarDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const formatArrivalDate = (date: Date): string => safeDateTimeFormat(navigator.language, { weekday: 'short', month: 'short', day: 'numeric' }).format(date);

export const calcExpectedArrivalDate = (selectedMethod: PayoutMethod): string =>
  formatArrivalDate(selectedMethod === 'instant' ? addCalendarDays(new Date(), INSTANT_PAYOUT_CALENDAR_DAYS) : addBusinessDays(new Date(), STANDARD_PAYOUT_BUSINESS_DAYS));

// Keep in sync with commerce service: https://github.com/joylifeinc/commerce_service/blob/main/src/delegates/finance/platformAccount/payoutFeeCalculator.ts#L24
export const calcFeeInMinorUnits = (amountInMinorUnits: number, fee: PayoutFee): number => {
  if (fee.freeThresholdInMinorUnits != null && amountInMinorUnits < fee.freeThresholdInMinorUnits) {
    return 0;
  }
  const totalFee = Math.floor(amountInMinorUnits * fee.rate) + fee.fixedValueInMinorUnits;
  if (fee.minFeeInMinorUnits != null) {
    return Math.max(fee.minFeeInMinorUnits, totalFee);
  }
  return totalFee;
};
